import {
  AUTH_LOGIN,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_ERROR,
  AUTH_LOGOUT,
  AUTH_SOCIAL_LOGIN,
  AUTH_SOCIAL_LOGIN_SUCCESS,
  AUTH_SOCIAL_LOGIN_ERROR,
  AUTH_SET_IDCOLEGIO,
  AUTH_API_ERROR,
} from "./actionTypes"

export const authLoginUser = (user, history) => {
  return {
    type: AUTH_LOGIN,
    payload: { user, history },
  }
}

export const authLoginUser2 = (user, history) => {
  return {
    type: AUTH_LOGIN,
    payload: { user, history },
  }
}

export const authLoginSuccess = user => {
  return {
    type: AUTH_LOGIN_SUCCESS,
    payload: user,
  }
}

export const authLoginFail = error => {
  console.log("actions.js::authLoginFail::linea35::error:", error)
  return {
    type: AUTH_LOGIN_ERROR,
    payload: error,
  }
}

export const authLogoutUser = history => {
  return {
    type: AUTH_LOGOUT,
    payload: { history },
  }
}

export const authLogoutUserSuccess = history => {
  return {
    type: AUTH_LOGOUT,
    payload: { history },
  }
}

export const authSocialLogin = (type, history, idColegio, GMT_Offset) => {
  return {
    type: AUTH_SOCIAL_LOGIN,
    payload: { type, history, idColegio, GMT_Offset },
  }
}

export const authSocialLoginSuccess = (
  type,
  history,
  idColegio,
  GMT_Offset
) => {
  return {
    type: AUTH_SOCIAL_LOGIN_SUCCESS,
    payload: { type, history, idColegio, GMT_Offset },
  }
}

export const authSocialLoginError = error => {
  return {
    type: AUTH_SOCIAL_LOGIN_ERROR,
    payload: error,
  }
}

export const authSetIdColegio = id => {
  return {
    type: AUTH_SET_IDCOLEGIO,
    payload: id,
  }
}

export const authSetIdCampus = id => {
  return {
    type: AUTH_SET_IDCAMPUS,
    payload: id,
  }
}

export const authSetListaCampus = dataCampi => {
  return {
    type: AUTH_SET_LISTACAMPI,
    payload: dataCampi,
  }
}

export const authApiError = error => {
  return {
    type: AUTH_API_ERROR,
    payload: error,
  }
}
